<template>
  <div v-if="errorMessages.length > 0" class="errorfield livenex--inner">
    <ul>
      <div>下記の内容を正しく入力してください。</div>
      <li
        v-for="(errorMessage, index) in errorMessages"
        :key="index"
        style="margin-bottom: 0px;"
      >
        {{ errorMessage }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ErrorMessages",
  data() {
    return {};
  },
  props: {
    errorMessages: undefined
  }
};
</script>
